import React, { FC } from 'react';
import { Table } from 'react-bootstrap';
import { PackageCartSummary } from '../../types/api/cart/PackageCartSummary';

interface Props {
    cart: readonly PackageCartSummary[];
    total: string;
  }

export const EmployeeContributionsTable: FC<Props> = ({ cart, total }) => {
    return (
        <Table striped>
            <thead>
                <tr>
                    <th className="e-header" colSpan={3}>Employee Contributions</th>
                </tr>
            </thead>
            <tbody>
                {cart.map(c => {
                    return (
                        <tr key={c.policyId}>
                            <td className="font-weight-bold">{c.planTypeDisplayName}</td>
                            {c.employeePreTaxContribution === 0 && c.employeePostTaxContribution === 0 && (
                                <React.Fragment>
                                    <td className="text-right"></td>
                                    <td className="text-right">$0.00</td>
                                </React.Fragment>
                            )}
                            {c.employeePreTaxContribution > 0 && (
                                <React.Fragment>
                                    <td className="text-right">Pre-Tax</td>
                                    <td className="text-right">${c.employeePreTaxContribution.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td>
                                </React.Fragment>
                            )}
                            {c.employeePostTaxContribution > 0 && (
                                <React.Fragment>
                                    <td className="text-right">Post-Tax</td>
                                    <td className="text-right">${c.employeePostTaxContribution.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td>
                                </React.Fragment>
                            )}
                        </tr>
                    );
                }
                )}
                <tr>
                    <td className="font-weight-bold">Total</td>
                    <td />
                    <td className="font-weight-bold text-right">${total}</td>
                </tr>
            </tbody>
        </Table>
    );
};
